export default __webpack_public_path__ + "static/media/autonomy_green.846234be.svg";